import React, { useEffect, useState } from 'react';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import { getResourceForStoryWidget, decodeJSScriptString, isDeviceTypeWeb, } from './helpers';
import IoElement from '../IOElement';
import { Wrapper, Title, DynamicHtmlWrapper, DynamicHtmlContainer, } from './css';
const Story = (widgetData) => {
    const { params, isServer, trackingData, id, } = widgetData;
    const { theme = '', titleAlign = 'left', html, appWebviewHtml, jsScript, appWebviewJsScript, extraStyleForDynamicHtml, isStaticStoryWidget, } = params;
    // for CSR, The document will have window so initializing it before will have actual html
    const initialHtmlForCSR = typeof window !== 'undefined' ? getResourceForStoryWidget(html, appWebviewHtml) : html;
    // by default HTML resources are taken for rendering, as SEO required there
    const [htmlToRender] = useState(initialHtmlForCSR);
    /*
      This function is executed when Story Widget Type = DYNAMIC_HTML
      It's a simple function which will create an IFrame element,
      and append it in "sw-dh {id}" div.
      DYNAMIC_HTML is HTML + JS
      HTML -> Body String (content)
      JS -> consist of JS script element in string {encoded}
    */
    const loadDynamicHtmlIFrame = (htmlData, jsData) => {
        try {
            // skip incase html empty, no rendering required
            if (!htmlData && !jsData) {
                return;
            }
            const { height, width, className } = extraStyleForDynamicHtml || {};
            const jsToLoad = decodeJSScriptString(jsData);
            // adding extra class for iframe
            const iframeClass = ['iframe-dsw', `iframe-${id}`];
            if (className && className.length > 0) {
                iframeClass.push(className);
            }
            // creating iFrame and adding details
            const iframe = document.createElement('iframe');
            const iframeContent = `<!DOCTYPE html>${htmlData}${jsToLoad}</html>`;
            iframe.srcdoc = iframeContent;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.style.border = '0px';
            iframe.style.height = height;
            iframe.style.maxWidth = width;
            iframe.classList.add(...iframeClass);
            iframe.id = 'iframe-dsw';
            document.getElementById(`sw-dh ${id}`).appendChild(iframe);
        }
        catch (error) {
            // eslint-disable-next-line no-console
        }
    };
    useEffect(() => {
        // when in client, again get actual platform and reload component based on Html and JS
        const htmlResource = getResourceForStoryWidget(html, appWebviewHtml);
        const jsResource = getResourceForStoryWidget(jsScript, appWebviewJsScript);
        // Dynamic Html Case
        if (!isStaticStoryWidget) {
            loadDynamicHtmlIFrame(htmlResource, jsResource);
        }
    }, []);
    const handleIntersect = () => {
        ImpressionsHandler.handleImpression(trackingData);
    };
    const handleIntersectV2 = () => {
        ImpressionsHandler.handleImpressionV2(trackingData);
    };
    const exitCallBackHandler = () => {
        ImpressionsHandler.removeImpression(trackingData);
    };
    const renderTitle = () => theme && theme.length > 0 && React.createElement(Title, { alignment: titleAlign, className: "story-title" }, theme);
    // Dynamic Html Renderer
    const renderDynamicHtml = () => (React.createElement(React.Fragment, null,
        renderTitle(),
        React.createElement(DynamicHtmlWrapper, { id: `sw-dh-wrapper ${id}` },
            React.createElement(DynamicHtmlContainer, { id: `sw-dh ${id}` }))));
    // condition for dynamic key required in static story widget: webview issue
    const isDynamicKeyReqForStaticStoryWidget = () => !!(isStaticStoryWidget
        && !isServer
        && !!(appWebviewHtml
            && appWebviewHtml.length > 0)
        && !(isDeviceTypeWeb()));
    return (React.createElement(React.Fragment, null,
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, exitCallBack: exitCallBackHandler, onIntersectV2: handleIntersectV2 }, isStaticStoryWidget
            ? (React.createElement(Wrapper, { key: isDynamicKeyReqForStaticStoryWidget() ? `sw-sh ${id} ${new Date().getTime()}` : `sw-sh ${id}`, className: "story-widget" },
                renderTitle(),
                React.createElement("div", { 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: { __html: htmlToRender }, id: `sw-sh ${id}` })))
            : renderDynamicHtml())));
};
export default Story;
